import { createContext, useContext, useEffect, useState } from "react";

const CurrencyContext = createContext(null);
const STORAGE_KEY = "jby_currency_v1";
// Conservative FX (admin can edit per-product price_inr for exact INR pricing)
const INR_RATE = 83;
const FX_FROM_USD = { USD: 1, EUR: 0.92, AED: 3.67 };

export const CURRENCIES = [
  { code: "INR", symbol: "₹" },
  { code: "USD", symbol: "$" },
  { code: "EUR", symbol: "€" },
  { code: "AED", symbol: "د.إ" },
];
const CODES = CURRENCIES.map((c) => c.code);

const GULF_TZ = ["Asia/Dubai", "Asia/Muscat", "Asia/Qatar", "Asia/Bahrain", "Asia/Riyadh", "Asia/Kuwait"];

function detectCurrency() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const lang = navigator.language || "";
    if (tz.includes("Asia/Kolkata") || tz.includes("Asia/Calcutta") || lang.startsWith("hi") || lang === "en-IN") return "INR";
    if (GULF_TZ.some((z) => tz.includes(z))) return "AED";
    if (tz.startsWith("Europe/")) return "EUR";
  } catch {}
  return "USD";
}

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    if (typeof window === "undefined") return "INR";
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && CODES.includes(saved)) return saved;
    return detectCurrency();
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, currency); } catch {}
  }, [currency]);

  const format = (usdPrice, inrPrice) => {
    if (currency === "INR") {
      const v = inrPrice ?? Math.round((usdPrice || 0) * INR_RATE);
      return `₹${v.toLocaleString("en-IN")}`;
    }
    if (currency === "USD") return `$${(usdPrice || 0).toFixed(2)}`;
    const v = (usdPrice || 0) * FX_FROM_USD[currency];
    if (currency === "EUR") return `€${v.toFixed(2)}`;
    return `AED ${v.toFixed(2)}`;
  };

  const value = { currency, setCurrency, format };
  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
};

export const useCurrency = () => useContext(CurrencyContext);
